import "swiper/css";
import "swiper/css/pagination";
import { useEffect, useState } from "react";
import PublicLayout from "@/components/layouts/bootstrap/PublicLayout";
import { getPlans } from "@/api/polls";
import { numberFormat } from "@/lib/utils";
import { useToasts } from "@/hooks/toasts";
import Link from "next/link";
import { Table } from "react-bootstrap";
import Seo from "@/components/Seo";

export default function Pricing()
{
    const [estimateBreakdown, setEstimateBreakdown] = useState({
        baseFee: 49,
        rate: 0,
        meteredFee: 0,
        totalPoll: 49,
        total: 53.9,
        gst: 4.9,
    });

    const [planDetails, setPlanDetails] = useState([]);
    const [voters, setVoters] = useState("");
    const [plan, setPlan] = useState("");
    const { addToast } = useToasts();

    useEffect(() =>
    {
        getPlans()
            .then((response) =>
            {
                const sortedPlans = response.data.data.sort(
                    (a, b) => a.from_vote_count - b.from_vote_count
                );
                setPlanDetails(sortedPlans);
            })
            .catch(console.error);
    }, []);

    const calculateFee = (numVoters) =>
    {
        if (!planDetails.length) return null;

        let matchedPlan = null;

        for (const plan of planDetails)
        {
            if (
                numVoters >= plan.from_vote_count &&
                (plan.to_vote_count === null || numVoters <= plan.to_vote_count)
            )
            {
                matchedPlan = plan;
                setPlan(matchedPlan);
                break;
            }
        }

        if (!matchedPlan) return null;
        const baseFee = matchedPlan.base_fee || 49;
        const rate = matchedPlan.price / 100 || 0;
        const meteredFee = numVoters * rate;
        const totalPoll = baseFee + meteredFee;
        const gst = totalPoll * 0.10;
        const total = totalPoll + gst;

        return {
            baseFee,
            rate,
            meteredFee,
            totalPoll,
            gst,
            total,
            planName: matchedPlan.name
        };
    };


    const handleChange = (e) =>
    {
        let raw = e.target.value.replace(/[^0-9]/g, "");

        if (raw === "")
        {
            setVoters("");
            return;
        }
        const numberValue = parseInt(raw, 10);
        setVoters(numberValue);
    };

    const handleEstimate = () =>
    {
        const plainNumber = parseInt(voters, 10);
        if (isNaN(plainNumber) || plainNumber < 0)
        {
            addToast("danger", "Please enter a valid number of voters.");
            return;
        }
        const result = calculateFee(plainNumber);
        if (result)
        {
            setEstimateBreakdown(result);
        } else
        {
            addToast("danger", "No matching plan found for given voters count.");
        }
    };

    return (

        <div className="responsiveZindex">
            <Seo
                title="Polling Software Pricing | Plans for Teams, Events & Education"
                description="Compare pricing plans for our live polling platform. Choose the best plan for meetings, events, classrooms, and audience engagement."
                canonical="https://instantpolls.online/pricing"
            />
            <section className="hero-pricing d-flex align-items-center text-white responsiveZindex">
                <div className="container hero-inner">
                    <div className="hero-copy">
                        <h1>Simplicity at its Core. Affordability at its Heart.</h1>
                        <Link href="/register" passHref>
                            <button
                                className="btn btn-primary fw-bold fs-1"
                            >
                                Get Started with a Free Poll
                            </button>
                        </Link>
                    </div>
                </div>
            </section>

                {/* pricing */}
                <section className="py-5 mobileRespPadding responsiveZindex">
                    <div className="container">

                        <div className="row g-5 align-items-stretch">

                            {/* Heading */}
                            <div className="col-lg-12 p-0">
                                <h2 className="fw-bold secondaryColor mb-1 text-start">
                                    Monthly Base Fee $49 /month* (Excluding GST)
                                </h2>
                            </div>

                            {/* LEFT COLUMN */}
                            <div className="col-lg-3 p-0">
                                <div className="border h-100 p-3">
                                    <ul className="ps-4 small" style={{ listStyleType: "disc" }}>
                                        <li className="mb-2">All our features are available to all users.</li>
                                        <li className="mb-2">All Prices excluding GST</li>
                                        <li className="mb-2">
                                            Base Fee is $49 per month and only charged if a minimum of one Poll is raised
                                            during the month. Base Fee includes unlimited monthly Polls.
                                        </li>
                                        <li className="mb-2">
                                            Fees are calculated and deducted on the 1st day of the following month.
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            {/* MIDDLE COLUMN */}                                {/* MIDDLE COLUMN */}
                            <div className="col-lg-6 pe-0 d-flex mobilePadd0">
                                <div className="table-responsive h-100 w-100 d-flex">
                                    <Table
                                        responsive
                                        className="mb-0 align-middle text-center table-bordered pricing-table h-100 w-100"
                                        style={{ tableLayout: "fixed" }}
                                    >
                                        <thead className="table-light">
                                            <tr>
                                                <th className="text-center py-3">From</th>
                                                <th className="text-center py-3">To</th>
                                                <th className="text-center py-3">Fee per Voter</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {Array.isArray(planDetails) &&
                                                planDetails.map((plan, index) => (
                                                    <tr key={index}>
                                                        <td className="Pricingpadding text-center">
                                                            {numberFormat(plan.from_vote_count, 0)}{" "}
                                                            {plan.from_vote_count === 1 ? "Vote" : "Voters"}
                                                        </td>
                                                        <td className="Pricingpadding text-center">
                                                            {plan.to_vote_count
                                                                ? numberFormat(plan.to_vote_count, 0) + " Voters"
                                                                : "Over"}
                                                        </td>
                                                        <td className="Pricingpadding text-center">
                                                            {plan?.price != null ? `${plan.price} Cents` : "N/A"}
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </Table>


                                </div>
                            </div>

                            {/* RIGHT COLUMN */}
                            <div className="col-lg-3 mobilePadd0">
                                <div className="h-100 d-flex flex-column">

                                    <div className="card bg-light border flex-fill" style={{ borderRadius: "0px" }}>
                                        <div className="card-body d-flex flex-column justify-content-between h-100 pt-0">

                                            <div>
                                                <p className="fw-bold mb-0 pt-1" style={{ fontSize: "14px" }}>
                                                    Fee Estimator
                                                </p>

                                                <p className="small mb-2">
                                                    Use our Fee Estimator to get a quick preview of your total cost.
                                                </p>

                                                <label htmlFor="votersInput" className="form-label fw-semibold mt-1">
                                                    Expected Voters
                                                </label>

                                                <input
                                                    type="number"
                                                    min={0}
                                                    id="votersInput"
                                                    className="form-control mb-2"
                                                    placeholder="Enter number of voters"
                                                    value={voters}
                                                    onInput={handleChange}
                                                />

                                                <button
                                                    className="btn btn-primary w-100 mt-1 mb-2"
                                                    onClick={handleEstimate}
                                                >
                                                    Get Estimate
                                                </button>

                                                <div className="row small">
                                                    <div className="col-8">Base Fee:</div>
                                                    <div className="col text-end">
                                                        ${estimateBreakdown.baseFee.toLocaleString(undefined, { maximumFractionDigits: 2 })}
                                                    </div>
                                                </div>

                                                <div className="row small">
                                                    <div className="col-8">Fee per Voter:</div>
                                                    <div className="col text-end">
                                                        ${estimateBreakdown.rate.toLocaleString(undefined, { maximumFractionDigits: 20 })}
                                                    </div>
                                                </div>

                                                <div className="row small">
                                                    <div className="col-6">Metered Charges:</div>
                                                    <div className="col text-end">
                                                        ${estimateBreakdown.meteredFee.toLocaleString(undefined, { maximumFractionDigits: 2 })}
                                                    </div>
                                                </div>

                                                <hr className="my-2" />

                                                <div className="row small">
                                                    <div className="col-6">Total Poll:</div>
                                                    <div className="col text-end">
                                                        ${estimateBreakdown.totalPoll.toLocaleString("en-AU", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}
                                                    </div>
                                                </div>
                                                <div className="row small">
                                                    <div className="col-6">GST (10%):</div>
                                                    <div className="col text-end">
                                                        ${estimateBreakdown.gst.toFixed(2)}
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="row small">
                                                    <div className="col-6"><strong>Total:</strong></div>
                                                    <div className="col text-end">
                                                        ${estimateBreakdown.total.toFixed(2)}
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div >
                </section >

                <section className="features py-5 realTime responsiveZindex">
                    <div className="container">
                        <div className="row g-4">
                            <div className="col-12 col-md-6 col-lg-4">
                                <div className="rfeature-card d-flex">
                                    <div>
                                        <div className="rfeature-title">Real-Time Sentiment Tracking</div>
                                        <p className="rfeature-text">Politicians, media outlets, and business can instantly gauge public opinion, track trends, and make data-driven decisions in real time.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6 col-lg-4">
                                <div className="rfeature-card d-flex">
                                    <div>
                                        <div className="rfeature-title">Instant Result Visualisation</div>
                                        <p className="rfeature-text">No waiting for post-event reports - responses dynamically update on screen, providing immediate insights to keep engagement high.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6 col-lg-4">
                                <div className="rfeature-card d-flex">
                                    <div>
                                        <div className="rfeature-title">Full White-Label Polling Solution</div>
                                        <p className="rfeature-text">Customise every aspect of your polls with  your logo, colours & fonts, ensuring a seamless experience for your audience.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </div>
    );
}
Pricing.getLayout = (page) => <PublicLayout>{page}</PublicLayout>;